"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValorCaracteristica = void 0;
var ValorCaracteristica = /** @class */ (function () {
    function ValorCaracteristica() {
        this._id = { c: '', v: '' };
        this.idCaract = '';
        this.valor = '';
    }
    return ValorCaracteristica;
}());
exports.ValorCaracteristica = ValorCaracteristica;
//# sourceMappingURL=ValorCaracteristica.js.map